import fetch from '@/utils/fetch';

const model = {
  state: {
    loading: false,
    // searchCondition: {
    //   startTime: '',
    //   endTime: '',
    // },
    guessLikeList: [],
    cartList: [],
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { dataMarketing }, getState }) => ({
    // setSearchCondition(params) {
    //   dataMarketing.setState({
    //     searchCondition: {
    //       startTime: params[0],
    //       endTime: params[1],
    //     },
    //   });
    // },
    async getData(params) {
      dataMarketing.setState({ loading: true });
      const { shop_id } = getState().basic;
      const data = await fetch('/merchant/dataanalyse/marketingdata', {
        params: {
          shop_id,
          ...params,
        },
      });
      dataMarketing.setState({ loading: false });
      if (data) {
        dataMarketing.setState({
          guessLikeList: data.guess_like_data,
          cartList: data.trolley_recom_data,
        });
      }
    },
  }),
};

export default model;
